import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  extendSessionModal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '1200!important',
  },
  extendSessionBody: {
    position: 'absolute',
    width: '620px',
    backgroundColor: Theme.palette.white,
    boxShadow: `0 2px 4px 0 ${Theme.palette.shadowOpacity}`,
    [Theme.breakpoints.down('md')]: {
      width: '580px',
    },
    [Theme.breakpoints.down('sm')]: {
      width: 'auto',
      maxWidth: '400px',
    },
  },
  extendSessionTitle: {
    fontSize: '36px',
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    padding: '60px 80px 10px 80px',
    [Theme.breakpoints.down('lg')]: {
      fontSize: '30px',
    },
    [Theme.breakpoints.down('md')]: {
      padding: '60px 60px 10px 60px',
    },
    [Theme.breakpoints.down('sm')]: {
      padding: '40px 20px 10px 20px',
    },
  },
  extendSessionContent: {
    paddingRight: '80px',
    paddingLeft: '80px',
    fontFamily: Theme.typography.base.regular,
    color: Theme.palette.gray[750],
    fontSize: '18px',
    height: 'auto',
    [Theme.breakpoints.down('lg')]: {
      fontSize: '16px',
    },
    [Theme.breakpoints.down('md')]: {
      paddingRight: '60px',
      paddingLeft: '60px',
    },
    [Theme.breakpoints.down('sm')]: {
      paddingRight: '20px',
      paddingLeft: '20px',
    },
  },
  extendSessionFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '40px 40px 60px 40px',
    gap: 20,

    [Theme.breakpoints.down('md')]: {
      padding: '30px 40px 60px 30px',
    },
    [Theme.breakpoints.down('sm')]: {
      height: '50px',
      minWidth: '132px',
      justifyContent: 'flex-start',
      padding: '30px 20px 40px 20px',
    },
  },
}));

export default useStyles;
